define(
    'views/sortable_admin_forums.view',[
        'loader',
        'config',
        'helper',
        'sandbox'
    ],
    function(Loader, Config, Helper, Sandbox)
    {
        var $ = Loader.$;
        var _ = Loader._;

        var SortableAdminForumsView = Loader.Backbone.View.extend(
            {
                routes: {
                    "/admin_forums.php": "sortable"
                },

                initialize: function()
                {
                    var _this = this;
                    _.bindAll(this, 'render');

                    this.model.on('startApplication', function(){
                        Helper.filterRoutes(_this.routes, _this);
                    });
                },

                render: function()
                {
                    return this;
                },

                sortable: function()
                {
                    var _this = this;

                    $("div.adfs-box:gt(0)")
                        .attr({"title":"Перетащите, чтобы отсортировать"})
                        .sortable({
                            opacity: 0.6,
                            axis: 'y',
                            containment: 'parent',
                            tolerance: 'pointer',
                            update: function(event, ui) {
                                _this.sortPosForums();
                            }
                        });

                    $("#pun-admain fieldset p:first")
                        .css({"position":"relative"});

                    _this.sortPosForums();
                },

                sortPosForums: function()
                {
                    i = 1;
                    $('div.adfs-box:gt(0)').each(function(i) {
                        $('div.adfs-box:eq('+(i+1)+') p').each(function(i) {
                            t = i+1
                            this.getElementsByTagName("input")[0].value = t
                        });
                        i = 1;
                    });

                }
            });

        return {
            initialize: function(model)
            {
                return new SortableAdminForumsView({
                    el: $("#pun-admain2"),
                    model: model
                })
            }
        }
    }
);
